import { Box, LoadingOverlay } from '@mantine/core';
import { useContext, useEffect, useState } from 'react';
import AppShellLayout from './components/layout/AppShellLayout';
import { useRequestInProgress } from './services/pending-requests';
import { AppCtx } from './provider/AppContext';

function App() {
  const [loaderVisible, setLoaderVisible] = useState(false);
  const appContex = useContext(AppCtx);

  // Il loader parte da solo con ogni chiamata al server e blocca i clic, anche sopra i
  // modali: un "Salva" che tarda non deve sembrare fermo, né poter partire due volte.
  const requestInProgress = useRequestInProgress();

  useEffect(() => {
    setLoaderVisible(appContex.showLoader);
  }, [appContex.showLoader])

  return (
    <>
      <Box>
        {/* Un solo loader per tutta l'app: lo accendono le pagine (caricamento) e, da sole, le
            chiamate al server. Copre anche i modali. */}
        <LoadingOverlay visible={loaderVisible || appContex.onLoading || requestInProgress} zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }} loaderProps={{ color: 'cyan', type: 'dots' }}
          style={{ position: 'fixed', inset: 0 }} />
      </Box>

      <AppShellLayout />
    </>
  );
}

export default App;